module.exports = __webpack_public_path__ + "img/pleisure_bodyimage06-6.5815b26d.jpg";